import { defineComponent as i, openBlock as o, createElementBlock as e, mergeProps as m, unref as n, renderSlot as u, createElementVNode as l, createCommentVNode as g } from "vue";
import { useScalarIcon as V } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, A = { key: 1 }, f = { key: 2 }, k = { key: 3 }, M = { key: 4 }, h = { key: 5 }, w = {
  name: "ScalarIconMapPinSimple"
}, S = /* @__PURE__ */ i({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: a } = V(s);
    return (p, t) => (o(), e("svg", m({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, n(d)), [
      u(p.$slots, "default"),
      n(a) === "bold" ? (o(), e("g", Z, t[0] || (t[0] = [
        l("path", { d: "M188,72a60,60,0,1,0-72,58.79V232a12,12,0,0,0,24,0V130.79A60.09,60.09,0,0,0,188,72Zm-60,36a36,36,0,1,1,36-36A36,36,0,0,1,128,108Z" }, null, -1)
      ]))) : n(a) === "duotone" ? (o(), e("g", A, t[1] || (t[1] = [
        l("path", {
          d: "M176,72a48,48,0,1,1-48-48A48,48,0,0,1,176,72Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M184,72a56,56,0,1,0-64,55.42V232a8,8,0,0,0,16,0V127.42A56.09,56.09,0,0,0,184,72Zm-56,40a40,40,0,1,1,40-40A40,40,0,0,1,128,112Z" }, null, -1)
      ]))) : n(a) === "fill" ? (o(), e("g", f, t[2] || (t[2] = [
        l("path", { d: "M136,127.42V232a8,8,0,0,1-16,0V127.42a56,56,0,1,1,16,0Z" }, null, -1)
      ]))) : n(a) === "light" ? (o(), e("g", k, t[3] || (t[3] = [
        l("path", { d: "M182,72a54,54,0,1,0-60,53.66V232a6,6,0,0,0,12,0V125.66A54.07,54.07,0,0,0,182,72Zm-54,42a42,42,0,1,1,42-42A42,42,0,0,1,128,114Z" }, null, -1)
      ]))) : n(a) === "regular" ? (o(), e("g", M, t[4] || (t[4] = [
        l("path", { d: "M184,72a56,56,0,1,0-64,55.42V232a8,8,0,0,0,16,0V127.42A56.09,56.09,0,0,0,184,72Zm-56,40a40,40,0,1,1,40-40A40,40,0,0,1,128,112Z" }, null, -1)
      ]))) : n(a) === "thin" ? (o(), e("g", h, t[5] || (t[5] = [
        l("path", { d: "M180,72a52,52,0,1,0-56,51.83V232a4,4,0,0,0,8,0V123.83A52.05,52.05,0,0,0,180,72Zm-52,44a44,44,0,1,1,44-44A44.05,44.05,0,0,1,128,116Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  S as default
};
